import { ReducerAction } from '../ReducerAction';
import { Pines, Horarios } from '../../../domain/models/Pines';
import { ActionType } from '../ActionsTypes';

export class PinesAction {
    static setPines(pines: Pines): ReducerAction {
        return {
            type: ActionType.LIST_PINES_USUARIOS,
            payload: pines
        }
    }

    static getHorarios(horarios: Horarios): ReducerAction {
        return {
            type: ActionType.LIST_PINES_HORARIOS,
            payload: horarios
        }
    }
}